import * as Yup from "yup";

export const kycSchema = Yup.object({
    questions: Yup.array().of(
      Yup.object({
        text: Yup.string().required("Required"),
        type: Yup.string().required("Required"),
        options: Yup.array().of(
          Yup.string().when("type", {
            is: (type) => ["Dropdown", "Radio", "Checkbox"].includes(type),
            then: Yup.string().required("Required"),
          })
        ),
        required: Yup.boolean(),
        limit: Yup.number().positive("Must be greater than 0"),
        format: Yup.string(),
      })
    ),
  });
  